import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-80" data-mp="3uei1jdqmbm1a">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="c7k8e5u331sk">
        <h2 className="font-serif text-5xl leading-tight sm:text-6xl" data-id="element-82" data-mp="85fct1k2rv3a">
          You Are the Practitioner
          <br data-id="element-83" data-mp="m4f0o6zrk5ye" />
          <span className="text-amber" data-id="element-84" data-mp="m3wy6smicvi1">Your Practice Has Been Waiting For.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-85" data-mp="h6nb3jmlcvxd">
          The scattered searching stops today. The incomplete references end here. The professional
          practice you have been building — it finally has its foundation.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate" data-id="element-86" data-mp="14v6hftm2yymt">
          390+ pages · 11 complete guides · Visual correspondence charts · Printable resources ·
          Everything you need to build the energy healing practice you were always meant to have.
        </p>
        <div className="mt-10" data-id="element-87" data-mp="2h3rcs743ov9f">
          <Countdown dark={false} data-id="element-88" data-mp="2h4ssiow2a5xh" />
        </div>
        <div className="mt-10" data-id="element-89" data-mp="2h5knpylqy1n8">
          <CTAButton size="large" data-id="element-90" data-mp="2m2b2milter72">🚀 GET INSTANT ACCESS — $27 USD</CTAButton>
        </div>
        <p className="mt-5 text-xs leading-6 text-slate sm:text-sm" data-id="element-91" data-mp="2r1nrta05sact">
          🔒 Secure Payment · 💳 Card · 🌎 Local Currency &amp; Payment Options · ⚡ Instant Access ·
          ♾️ Lifetime Access
        </p>
      </Reveal>
    </section>;
}